var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMap = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14.35 20.775 9 18.9l-4.65 1.8a.9.9 0 0 1-.925-.113A.99.99 0 0 1 3 19.75v-14q0-.325.188-.575A1.13 1.13 0 0 1 3.7 4.8l4.65-1.575q.325-.1.65-.113t.65.113L15 5.1l4.65-1.8a.9.9 0 0 1 .925.112.99.99 0 0 1 .425.838v14a.93.93 0 0 1-.187.575 1.13 1.13 0 0 1-.513.375l-4.65 1.575a2.5 2.5 0 0 1-.65.113 1.6 1.6 0 0 1-.65-.113M14 18.55V6.85l-4-1.4v11.7zm2 0 3-1V5.7l-3 1.15zM5 18.3l3-1.15V5.45l-3 1z"
})));
export default SvgMap;